export const imageHelper = (content, format) => {
	if (!content) return null;
	if (content.formats && format && content.formats[format]) {
		return content.formats[format].url;
	} else {
		return content.url;
	}
};